import { Injector } from "@angular/core";
import { saveAs } from "file-saver";
import { FileResponse } from "./file-response";
import { TranslationResolver } from "../../../../helpers/translation-resolver";
import { TcmModalService } from "../../../../modules/tcm-common/services/tcm-modal.service";

export class FileBlobResponse implements FileResponse {
  $injector: Injector;
  blob: Blob;
  constructor(
    public name: string,
    public mimeType: string,
    blob: Blob,
    $injector: Injector
  ) {
    this.blob = blob;
    this.$injector = $injector;
  }

  async displayFileAsync(
    this: FileResponse,
    titleKey?: TranslationResolver
  ): Promise<any> {    
    const modalService: TcmModalService = this.$injector.get(TcmModalService);

    await modalService.showFilePreviewAsync(this, titleKey);
  }

  toBlobAsync(): Promise<Blob> {
    return Promise.resolve(this.blob);
  }

  save() {
    saveAs(this.blob, this.name.replace(new RegExp('"', "g"), ""));
  }
}
